import React, { useState,useContext,useRef } from "react";
import { useNavigate,Navigate } from "react-router-dom";
import {apiUrl} from '../constant';
import {userService} from '../services/authentication';
// import { ToastContainer, toast } from 'react-toastify';
import MyContext from "../contextapi/MyContext";
import logo from '../assets/images/businessbackground.jpg';
import '../assets/css/login.css';
import { Toast } from 'primereact/toast';
import Smallloader,{Smallloadertrans} from '../compnents/loader';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Resetpassword from './resetpassword';

const Login = () => {
  const toast = useRef(null);
  const mycontext = useContext(MyContext);
  const axios = require("axios");
  const history = useNavigate();
  const [inputFieldEmail, setInputemail] = useState({
    email: "",
  });

  const [inputFieldpass, setInputpassword] = useState({
    password: "",
  });
  const [error,setError]=useState(null);
  const [loggingin,setloggin] = useState(true);
  const [passwordtype,setpasstype] = useState(true);


  

  const authenticate = (e) => {
    e.preventDefault();
    var email = inputFieldEmail.email;
    var pass = inputFieldpass.password;
    if(email == '' || pass == ''){
    //   toast.error('All fields are Required !');
    //   toast.current.show({severity:'error', summary: 'Error', detail:'All fields are Required', life: 3000});
      return false;
    }
    var bodyFormData = new FormData();
    setloggin(false);
    userService.login(inputFieldEmail.email,inputFieldpass.password).then((response)=>{
       if(response == undefined){
           return;
       }
       if(response.status == 200){
        // toast.success(response.data.message);
        setloggin(true);
        mycontext.updateuserloggedinstatus(true);
        <Navigate to="/dashboard" replace />
        // window.location.href = '/dashboard';
       }else{
        console.log(response);
        setloggin(true);
        toast.current.show({severity:'error', summary: "Authentication", detail:`${response.data.error} Please check the Login credential`, life: 3000});
        // toast.error("Authenticate");
       }
    }).then((error) => {
        setloggin(true);
        console.log(error);
      //toast.error(error);
      
    });
        return;
    }

    const inputsHandleremail = (e) => {
        setInputemail({ [e.target.name]: e.target.value });
    };

    const inputsHandlerpass = (e) => {
        setInputpassword({ [e.target.name]: e.target.value });
    };
    

    const setpasstypedata = () =>{
        let icon = <></>; 
        if(passwordtype){
            icon =   (<> 
                     <label htmlFor="exampleInputPassword1" className="login-label">Password</label>
                        <div style={{position:'relative'}}>
                            <input type='password' name="password" className="form-control"  id="exampleInputPassword1" placeholder="Password" onChange={inputsHandlerpass}
                    required/>
                           <FaEyeSlash className="eyeicon-style" onClick={() => {setpasstype(false)}}/> 
                       </div></>);
             
        }else{
            icon =   (<> 
                <label htmlFor="exampleInputPassword1" className="login-label">Password</label>
                   <div style={{position:'relative'}}>
                       <input type='text' name="password" className="form-control"  id="exampleInputPassword1" placeholder="Password" onChange={inputsHandlerpass}
               required/>
                     <FaEye className="eyeicon-style" onClick={() => {setpasstype(true)}}/> 
                      
                  </div></>);
        }   
        return icon; 
    }

    function resetpage(){
        history('/forgotpassword');   
    }

    return (
        <>
            <div style={{display:'flex',justifyContent: 'center',height:'100vh',alignItems: 'center'}}>
                <Toast ref={toast} />
                <div className="login-container">
                  <form  role="form" onSubmit={(e) => authenticate(e)}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1" className="login-label">Email address</label>
                        <input type="text" name="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" 
                        onChange={inputsHandleremail}
                        required/>
                        {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                    </div>
                    <br></br>
                    <div className="form-group">
                        {setpasstypedata()}
                    </div>
                    <div className="form-check">

                        {/* <input type="checkbox" className="form-check-input" id="exampleCheck1"/>
                        <label className="form-check-label" for="exampleCheck1">Check me out</label> */}
                    </div>
                    <button type="submit" className="btn btn-primary">Sign In {!loggingin ? (<Smallloadertrans/>) : (<></>)} </button>
                    </form>
                      
                    <br/>
                    <br/>   
                    <button style={{background: 'transparent',
    border: 'none',
    color: '#0d6efd'}} onClick={() => resetpage()}>Forgot password</button>
                </div>

                <div style={{position: 'absolute',
    color: 'white',
    bottom: '14px',
}}>CopyRight © Corient Business Solutions | 2024</div>
            </div>
        </>
    );
}

export default Login;